import React, { useState, useContext, useEffect } from 'react';
import EkonomiskAnalysSums from '../../../../../EkonomiskAnalysSums/EkonomiskAnalysSums';
import { EkonomiskAnalysSideMenuContext } from '../../../../Context/EkonomiskAnalysSideMenuContext';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EkonomiskAnalysSummeringSelect from '../../../../EkonomiskAnalysSummeringSelect/EkonomiskAnalysSummeringSelect';
import { ISumData } from '../../../../../../Queries/EkonomiskAnalysSettingsQuery/EkonomiskAnalysSettingsQuery';

interface IProps {
  changed: boolean;
  onSumsChanged: (sums: ISumData[]) => void;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      pickSummeringContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginRight: -8,
      },
    } as const)
);

/**
 * En dialog där summeringsbegrepp för analysen kan ställas in.
 */
const EkonomiskAnalysSummering: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { classes } = useStyles();
  const [newSums, setNewSums] = useState<ISumData[]>([]);
  useEffect(() => {
    if (!props.changed) {
      setNewSums([]);
    }
  }, [props.changed]);

  const {
    newAnalysSettings,
    onChipSelectionChanged,
    expandedSumLevel,
    onVisaSummeringarChanged,
  } = useContext(EkonomiskAnalysSideMenuContext);
  const sums = newAnalysSettings != null ? newAnalysSettings.sums : [];

  const sumsChanged = (
    oldSums: ISumData[],
    sums: ISumData[],
    onSumsChanged: (sums: ISumData[]) => void
  ) => {
    setNewSums(prevNewSums => {
      let newSums = prevNewSums.filter(baseSum => {
        return sums.find(sum => sum === baseSum) !== undefined;
      });
      newSums = newSums.concat(
        sums.filter(newSum => !oldSums.find(oldSum => newSum === oldSum))
      );
      return newSums;
    });
    onSumsChanged(sums);
  };

  return (
    <>
      <EkonomiskAnalysSums
        sums={sums}
        newSums={newSums}
        onUpdate={(newSums: ISumData[]) =>
          sumsChanged(sums, newSums, props.onSumsChanged)
        }
        onChipSelectionUpdate={onChipSelectionChanged}
        changed={props.changed}
        expandedSumLevel={expandedSumLevel}
        visaSummeringar={newAnalysSettings.visaSummeringar}
        onVisaSummeringarChanged={onVisaSummeringarChanged}
      />
      <div className={classes.pickSummeringContainer}>
        <EkonomiskAnalysSummeringSelect
          selectedSums={sums}
          onUpdate={(newSums: ISumData[]) =>
            sumsChanged(sums, newSums, props.onSumsChanged)
          }
        />
      </div>
    </>
  );
};

export default EkonomiskAnalysSummering;
